module.exports = __webpack_public_path__ + "static/media/OnmoLogo.6523e946.svg";